export default {"src":"/_next/static/media/logo-light.695409b5.svg","height":46,"width":162,"blurWidth":0,"blurHeight":0};